// filepath: src/components/Header.js
import React from 'react';

function Header() {
  return (
    <header>
      <h1>☕ Coffee Excuse Generator</h1>
      <p className="subtitle">AI-powered reasons for your next coffee break</p>
    </header>
  );
}

export default Header;